export enum PilingType {
  Screw = 'screw',
  Pouding = 'pouding',
  Helical = 'helical'
}

export enum PilingStatus {
  awaitingInstallation = 'awaiting_installation',
  awaitingQC = 'awaiting_qc',
  escalated = 'escalated',
  awaitingRework = 'awaiting_rework',
  installed = 'installed',
}

export interface CreatePilingRequest {
  projectID: string;
  pilingID: string;
  latitude: number;
  longitude: number;
}

export interface UpdatePilingRequest {
  latitude?: number;
  longitude?: number;
  /**
   * Single-piling PUT only. When true and status is awaiting_rework, API moves to awaiting_qc
   * and refreshes reworkedByID / reworkTimestamp even if Rework - … values are unchanged.
   */
  submitReworkForQc?: boolean;
}

export class Piling {
  projectID: string = '';
  pilingID: string = '';
  status: PilingStatus = PilingStatus.awaitingInstallation;
  qcNotes: string = '';
  [attributeName: string]: string | number | boolean | string[] | undefined;

  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

export function getStatusColor(status: string): string {
  if (!status) return '';
  switch (status.toLowerCase()) {
    case PilingStatus.installed:
    case 'installed':
      return 'installed';
    case PilingStatus.awaitingQC:
    case 'awaiting_qc':
      return 'awaiting-qc';
    case PilingStatus.awaitingInstallation:
    case 'awaiting_installation':
      return 'awaiting-installation';
    case PilingStatus.escalated:
    case 'escalated':
      return 'escalated';
    default:
      return '';
  }
} 